var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-1181 -21)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1181 21)",
    fill: "#f1f6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M23.855,11.892A13.364,13.364,0,0,0,12,4.5,13.366,13.366,0,0,0,.145,11.892a1.348,1.348,0,0,0,0,1.216A13.364,13.364,0,0,0,12,20.5a13.366,13.366,0,0,0,11.855-7.392A1.348,1.348,0,0,0,23.855,11.892ZM12,18.5a6,6,0,1,1,6-6A6,6,0,0,1,12,18.5Zm0-10a3.971,3.971,0,0,0-1.055.158,1.994,1.994,0,0,1-2.788,2.788A3.991,3.991,0,1,0,12,8.5Z",
    transform: "translate(1193 32.5)",
    fill: "#5596f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.05b2be6381cfa2a21ea2a619fa156fbe.svg";
export { ForwardRef as ReactComponent };